import { useMutation, UseMutationResult } from '@taxdown/zeno-sama-query';
import { AxiosResponse } from 'axios';
import { getErrorDetail } from 'Services/errors';
import EventService from 'Services/events';
import i18n from 'Services/i18n';
import Notify, { AlertTypes } from 'Services/notification';
import SatService from 'Services/sat';
import { UpdateSatPasswordType } from 'Services/sat/types';
import { history } from 'Store';
import { TAX_YEAR } from 'Config';
import { QueryKeys } from 'Types/common';
import { CredentialsType } from '../../types';

type satPasswordProp = {
  onHideModal: () => void;
  route: string;
};

export const useFetchUpdateSatPassword = ({
  onHideModal,
  route,
}: satPasswordProp): UseMutationResult<AxiosResponse<unknown>, UpdateSatPasswordType, unknown> =>
  useMutation([QueryKeys.SAVE_SAT_PASSWORD], SatService.saveSatPasswordUser, {
    onSuccess: () => {
      onHideModal();
      EventService.taxAgencyCredentialUpdate(TAX_YEAR, CredentialsType.RFC);
      history.push(route);
      Notify.sendNotification(i18n.t('common:Update.sat.password.success'), AlertTypes.success);
    },
    onError: error => {
      onHideModal();
      Notify.sendNotification(
        getErrorDetail(error) ?? i18n.t('account:Sat.updatePassword.failed'),
        AlertTypes.error
      );
    },
  });
